module.exports = __webpack_public_path__ + "static/media/classicos_masculino_acima_de_400.67765f88.jpg";